module.exports = __webpack_public_path__ + "images/fa-fa2024-bg-banner-mobile.webp";